export class ApiStatus {
    isActive: boolean;
    numberOfCalls: number;
    authToken: string;
    refreshToken: string;

    constructor() {
        this.isActive = false;
        this.numberOfCalls = 0;
        this.authToken = null;
        this.refreshToken = null;
    }
}